var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIconBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.661 12a.658.658 0 01-.485-.215.65.65 0 01-.173-.503l.16-1.774 7.453-7.452 2.33 2.329-7.451 7.451-1.774.161a.651.651 0 01-.06.003zm9.75-8.08l-2.33-2.33L9.479.193a.658.658 0 01.931 0l1.397 1.397a.659.659 0 010 .932L10.41 3.918v.001z",
    fill: "#2355FC"
  })));
}

export default SvgEditIconBlue;